import styled from '@emotion/styled'
import { faqRoute, privacyPolicyRoute, termsOfUseRoute } from '../../../common/constants/routes'
import { NextLink } from '../../../common/functionality/NextLink'
import { hoverOpacity } from '../../../common/style/HoverOpacityWrapper'
import { theme } from '../../../styles/theme'
import { tabletDownMq } from '../../../styles/mediaQueries'
import { useFranchiseDeploymentData } from '../../account/features/franchise-membership/hooks/useHost/useFranchiseDeploymentData'

const NavList = styled.ul`
  width: 100%;
  text-align: center;
  padding: 10px 10px;
`

const NavListItem = styled.li`
  font-weight: 400;
  line-height: 18px;
  color: ${theme.colors.grayscale700};
  background: ${theme.colors.grayscale000};

  display: inline;
  :not(:last-child) {
    margin-right: 40px;
    ${tabletDownMq} {
      margin-right: 30px;
    }
  }
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.04em;

  ${hoverOpacity}
`

export const Footer = () => {
  const { isFranchiseUi } = useFranchiseDeploymentData()
  if (isFranchiseUi) return null
  return (
    <NavList>
      <NavListItem>
        <NextLink href={privacyPolicyRoute}>Privacy Policy</NextLink>
      </NavListItem>
      <NavListItem>
        <NextLink href={termsOfUseRoute}>Terms of Use</NextLink>
      </NavListItem>
      <NavListItem>
        <NextLink href={faqRoute}>FAQ</NextLink>
      </NavListItem>
      <NavListItem>
        <NextLink href="/contact">Contact Us</NextLink>
      </NavListItem>
    </NavList>
  )
}
